import React from 'react';
import { Badge, Button } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import styles from './Button.module.scss';
const NotificationsButton = ({ unreadCount, isOpen, onClick }) => {
    const { t } = useTranslation();
    return (React.createElement(Badge, { count: unreadCount, className: styles.badge },
        React.createElement(Button, { shape: "circle", className: styles.button, "aria-label": t('notifications'), "aria-expanded": isOpen, onClick: onClick },
            React.createElement(BellOutlined, null))));
};
export default NotificationsButton;
